export default __webpack_public_path__ + "static/media/simonProcess.91186351.png";